module.exports = __webpack_public_path__ + "static/media/coffee-nov30-mb-en.f38825bd.jpg";